module.exports = __webpack_public_path__ + "static/media/baggage-unrecommended.b2591410.svg";